import React, {useContext, useRef} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import ContractsPopupFooter from "./contractsPopupFooter";
import ContractsContext from "./contractsContext";
import {documentOptions} from "./contractInterface";
import ContractsPopupFields from "./contractsPopupFields";
import LoadingSpinner from "../../ui/loadingSpinner";
import ContractSignPopup from "./signaturePadPopup";
import ReceiptSign from "./receiptSign";
import {getQuotePriceWithTaxes, getTotalPrice} from "../../../misc/helpers";
import {getDepositAmount} from "../../priceWorksheet/discountFunctions";


const ContractsPopupDocument = (props) => {

  const {contractLoading, changeContext, isSignaturePadVisible, fabricatorData, discountSections} = props;

  const Document = window.ReactPdfDocument;
  const Page = window.ReactPdfPage;

  const contractRef = useRef(null);
  const pageRef = useRef(null);
  const {pageRendered, receiptUrl, receiptPages, activeContract, activeContractPage,
    showPage, globalContractPage} = useContext(ContractsContext);

  if (contractLoading) {
    return <div className="contract-body"/>
  }

  const totalPrice = getTotalPrice();
  const grandTotal = getQuotePriceWithTaxes(totalPrice);

  const depositValue = +getDepositAmount(discountSections, grandTotal, fabricatorData) || 0;

  const file = receiptPages && receiptUrl && globalContractPage <= receiptPages
    ? receiptUrl
    : activeContract && activeContract.blobUrl ? activeContract.blobUrl : null;
  const isReceipt = file === receiptUrl;

  return (
    <div className="contract" ref={contractRef} style={{position:"relative"}}>
      {showPage && file ? null : <LoadingSpinner/>}
      {file ? (
        <div className="contract-body">
          <Document file={file}
                    onLoadSuccess={() => changeContext({showPage: true})}
                    options={documentOptions}>
            {showPage ? <Page ref={pageRef}
                              pageNumber={isReceipt ? globalContractPage : activeContractPage}
                              onRenderSuccess={() => changeContext({pageRendered: true})}
                              scale={1.5}
            /> : null}
            {showPage && isReceipt && (globalContractPage === receiptPages) && !fabricatorData.isLowes
            && !(fabricatorData.receiptSettings && fabricatorData.receiptSettings.hideSignatureField)
              ? <ReceiptSign/>
              : null}
          </Document>
          {activeContract && pageRendered ? <ContractsPopupFields pageRef={pageRef}
                                                                  grandTotal={grandTotal}
                                                                  depositValue={depositValue}
                                                                  contractRef={contractRef}
                                                                  changeContext={changeContext}/>  : null}
        </div>
      ) : null}
      <ContractsPopupFooter changeContext={changeContext}/>
      {isSignaturePadVisible ? <ContractSignPopup activeContract={activeContract}/> : null}
    </div>
  )
};

ContractsPopupDocument.propTypes = {
  changeContext: PropTypes.func,
}

const mapStateToProps = (store) => {
  const {step, isSignaturePadVisible} = store.contractSigningState;
  const {discountSections} = store.priceWorksheetState;
  return {
    step,
    isSignaturePadVisible,
    fabricatorData: store.fabricatorState,
    discountSections,
  };
};

export default connect(mapStateToProps)(ContractsPopupDocument)
